import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { defaultMemoize } from 'reselect';
import _noop from 'lodash/noop';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import ACTION_TYPES from './note.actionTypes';
export var VIEW_TYPE = {
  DEFAULT: 'default',
  COMPACT: 'compact'
};
export var getEditAction = defaultMemoize(function () {
  var onClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
  var isVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isSelected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop;
  var additionalInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EMPTY_OBJECT;
  return _objectSpread({
    label: __('Edit'),
    key: ACTION_TYPES.EDIT,
    iconName: 'icon-edit',
    size: 16,
    className: 'note-item__action-button',
    isSelected: isSelected,
    onClick: onClick,
    isVisible: isVisible
  }, additionalInfo);
});
export var getDeleteAction = defaultMemoize(function () {
  var onClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
  var isVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isSelected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop;
  var additionalInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EMPTY_OBJECT;
  return _objectSpread({
    label: __('Delete'),
    key: ACTION_TYPES.DELETE,
    iconName: 'icon-trash',
    size: 16,
    className: 'note-item__action-button',
    isSelected: isSelected,
    onClick: onClick,
    isVisible: isVisible
  }, additionalInfo);
});
export var getPinAction = defaultMemoize(function () {
  var onClick = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
  var isVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isSelected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop;
  var additionalInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EMPTY_OBJECT;
  return _objectSpread({
    label: __('Pin'),
    key: ACTION_TYPES.PIN,
    iconName: 'icon-pin',
    size: 16,
    className: 'note-item__action-button',
    isSelected: isSelected,
    onClick: onClick,
    isVisible: isVisible
  }, additionalInfo);
});
export var DEFAULT_AVATAR_SIZE = 40;